// extracted by mini-css-extract-plugin
export var createdDate = "_hv-1";
export var divider = "_hv-2";
export var headerDivider = "_hv-3";
export var messagesCard = "_hv-0";
export var messagesContainer = "_hv-7";
export var messagesContainerWrapper = "_hv-4";
export var pointerCapturingButtonBoxes = "_hv-a";
export var showLeftPanelButton = "_hv-9";
export var showMoreButton = "_hv-c";
export var showMoreButtonContainer = "_hv-b";
export var summaryTitle = "_hv-6";
export var systemMessageCardWrapper = "_hv-d";
export var topButtons = "_hv-8";
export var withPadding = "_hv-5";